import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 85vh;
  width: 100vw;
  margin-bottom: 2rem;
  .user-data-header {
    width: calc(90vw - 2rem);
    margin: 1rem auto;
    background: #ff6a00;
    background: linear-gradient(
      90deg,
      rgba(255, 106, 0, 1) 0%,
      rgba(247, 236, 236, 1) 80%,
      rgba(255, 106, 0, 1) 100%
    );
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    padding: 1rem;
    border-radius: 24px;
    color: #fff;
    .user-data-header-extra {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .user-img {
        width: 50px;
      }
      .location-icon {
        width: 25px;
        margin-right: 1rem;
      }
    }
  }
  .user-data-container {
    width: 90vw;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    .edit-icon {
      width: 25px;
      height: auto;
      cursor: pointer;
    }
    .container-left {
      width: 100%;
      .personal-information,
      .about-user-container,
      .standing-container {
        box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
        padding: 1rem;
        border-radius: 24px;
        width: calc(100% - 2rem);
        margin: 1rem 0;
        .user-data-content {
          a {
            text-decoration: none;
            color: #000;
          }
        }
      }
    }
    .container-right {
      flex-basis: 65%;
      width: 100%;
      .user-app-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 2rem 0;
        div {
          box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
          padding: 0.5rem;
          border-radius: 24px;
          width: 45%;
          h3 {
            font-size: 50px;
            margin: 0;
          }
        }
      }
      .stats-container {
        box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
        padding: 1rem;
        border-radius: 24px;
        .stats-container-header {
          .stats-container-header-buttons {
            display: flex;
            .chart-option {
              cursor: pointer;
              button {
                width: 100%;
                height: 50px;
                background: white;
                box-shadow: none;
                border: none;
                cursor: pointer;
                color: #000;
                font-size: 18px;
                font-weight: 700;
              }
              &.active {
                border-top: 5px solid orange;
                border-left: 1px solid lightGray;
                border-right: 1px solid lightGray;
              }
            }
            div {
              width: 30%;
            }
          }
          .stats-container-header-data {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .stats-container-header-data-extra {
              width: 100%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              div {
                flex-basis: 35%;
              }
            }
          }
        }
        .stats-container-content {
          width: 100%;
          overflow: scroll;
          table {
            width: 700px;
            text-align: left;
            thead {
              height: 100px;
            }
            tbody {
              tr {
                margin: 1rem 0;
                height: 50px;
              }
            }
          }
          .player-view {
            span.black {
              color: #000;
              font-weight: 700;
            }
          }
        }
      }
    }

    button {
      margin: 1rem auto;
      display: flex;
      margin: 0;
      align-items: center;
      justify-content: space-between;
      width: 30%;
      img {
        width: 15px !important;
      }
    }
  }

  .pop-up {
    position: absolute;
    width: 100vw;
    height: 100%;
    top: 10vh;
    left: 0;
    background: #fff;
    .pop-up-container {
      width: 30%;
      margin: auto;
      box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
      padding: 3rem;
      border-radius: 24px;
      .pop-up-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .popup-content form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        input {
          padding: 1rem;
        }
      }
    }
    .pop-up-footer {
      text-align: center;
      a {
        color: black;
        font-weight: 700;
        &:visited {
          color: black;
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .user-data-header {
      .user-data-header-extra {
        width: 50%;
        flex-direction: row;
        align-items: center;
        .user-img {
          width: 100px;
        }
        .location-icon {
          width: 25px;
          margin-right: 1rem;
        }
      }
    }
    .user-data-container {
      flex-direction: row;
      .container-left {
        width: 30%;
      }
      .container-right {
        width: 70%;
        .user-app-content {
          padding: 1rem;
          width: 100%;
          div {
            padding: 1rem;
          }
        }
        .stats-container {
          .stats-container-header {
            .stats-container-header-data
              .stats-container-header-data-extra
              div {
              flex-basis: 20%;
            }
          }
          .stats-container-content table {
            width: 100%;
          }
        }
      }
    }
  }
`;
